// import external dependencies
import 'jquery'

// Import everything from autoload
import 'D:/Websites/obara-transport.com/wp-content/themes/webme/resources/assets/scripts/autoload/_bootstrap.js'; import 'D:/Websites/obara-transport.com/wp-content/themes/webme/resources/assets/scripts/autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

import {loadDefaultJapaneseParser} from 'budoux'
const parser = loadDefaultJapaneseParser()

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
})

// Load Events
jQuery(document).ready(() => routes.loadEvents())

jQuery(($) => {
  $('.confirm').on('click', () => {
    let check = true
    $('form > dl dd input,form > dl dd textarea').each(function () {
      if (!$(this).val()) {
        check = false
      }
    })
    if (check) {
      const confirmContent = () => {
        let str = ''
        $('form').serializeArray().forEach(el => {
          if (el.name && el.name.match(/^(form)/)) {
            const label = $('label[for=\'' + el.name + '\']').text()
            str += `<div><dt>${label}</dt><dd>${el.value}</dd></div>`
          }
        })
        return str
      }
      $('.submit dl').prepend(confirmContent())
      $('.formConfirm').addClass('is-visible')
      return false
    }
  })
  $('.back').on('click', () => {
    $('.submit dl').empty()
    $('.formConfirm').removeClass('is-visible')
    return false
  })
  $('.wpcf7-submit').on('click', () => {
    $('.submit dl').empty()
    $('.formConfirm').removeClass('is-visible')
  })
  $('h2 span, .h2, h3 span, h4, .lead, .budoux').each(function(index, el) {
    parser.applyElement(el)
    $(el).replaceWith(el.outerHTML)
  })
  $('.tablepress td, .price-table2_body .price-table2_cell').each(function (index, el) {
    const numString = $(el).text()
    const num = Number(numString).toLocaleString()
    $(el).text(num)
  })
})
